<template>
    <div>
        <div class="mt-5 mb-5 ml-3">
            <h3>Evento: {{pedido.evento.name}}</h3> <h4 v-if="pedido.sesion">Sesion: {{pedido.sesion.fecha}}</h4>
        </div>
        <div class="mt-2 mb-5 ml-3">
            <button :disabled="codigosQR.length == 0" @click="showModal('send-' + pedido.id)" class="button">{{ $t('perfil.enviar_entradas') }}</button>
            <Button class="button ml-5" @click="$emit('atras')">{{$t('perfil.asiento_liberado_atras')}}</Button>
        </div>
        <div class="mr-3 ml-3">
            <b-table v-if="entradas" striped hover :items="items" :fields="fields">
                <template #cell(enviar)="row">
                    <b-checkbox v-model="row.item.enviar" @change="entradaEnviar(row.item.enviar,row.item.code)"></b-checkbox>
                </template>
            </b-table>
        </div>
        <SendTicketModal :id="pedido.id" :order_id="pedido.id" :qr_codes="codigosQR" :entradas_id="entradas_id" @close="closeModal"></SendTicketModal>
    </div>
</template>

<script>
import SendTicketModal from '@/components/frontend/perfil/SendTicketModal';
export default {
    props: ['pedido'],
    data(){
        return {
            loading: false,
            entradas: [],
            pedido_id: this.pedido.id,
            items: [],
            fields: [
                { key: 'code', label: 'CODE'},
                { key: 'enviado', label: 'ENVIADO'},
                { key: 'enviar', label: 'Enviar',},
            ],
            codigosQR : [],
            entradas_id: []
        }
    },
    created() {
        console.log(this.pedido);
        this.getEntradas();
    },
    methods: {
        getEntradas() {
            this.codigosQR = [];
            this.entradas_id = [];
            this.loading = true
            const params = {
                filters : {},
                pedido_id: this.pedido_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.pedidos.entradas'), params).then(res => {
                this.entradas = res.data.data;

                this.items = this.entradas.map(entrada => {
                    return {
                        code: entrada.qr_code,
                        enviado: entrada.enviado ? 'Si' : 'No',
                    }
                })

                this.loading = false;
            })
        },
        entradaEnviar(enviar, code){
            if(enviar){
                this.codigosQR.push(code);
                this.entradas.map(entrada => {
                    if(entrada.qr_code == code){
                        this.entradas_id.push(entrada.id);
                    }
                })
            }else{
                this.codigosQR = this.codigosQR.filter(codigo => codigo !== code);
                this.entradas.map(entrada => {
                    if(entrada.qr_code == code){
                        this.entradas_id = this.entradas_id.filter(id => id !== entrada.id);
                    }
                })
            }
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.getEntradas();
            this.$modal.hide(modal);
        },
    },
    components: {
        SendTicketModal
    }
}
</script>